import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {AgreementTerms} from "../../features/agreement";

const AgreementPage = () => (
  <FormPageLayout
    body={
      <AgreementTerms />
    }
  />
)

export default AgreementPage;
